// FBT
export const FBT = '/fbt';
export const FBT_DRIVER = '/fbt/driver';
export const FBT_VEHICLE = '/fbt/driver/vehicle/:code';

export const FBT_EXEMPTION = '/fbt/driver/exemption';
export const FBT_EXEMPTION_ADD = '/fbt/driver/exemption/:leaseId/add';
export const FBT_EXEMPTION_EDIT =
  '/fbt/driver/exemption/:leaseId/edit/:exemptionId';

export const FBT_DRIVER_REPORT = `${FBT_DRIVER}/report/:id`;



// WEBPACK FOOTER //
// ./src/features/fbt/routes/const.js